import { render, staticRenderFns } from "./rechnungfreigabe.vue?vue&type=template&id=35a7a4c0&scoped=true&"
import script from "./rechnungfreigabe.vue?vue&type=script&lang=js&"
export * from "./rechnungfreigabe.vue?vue&type=script&lang=js&"
import style0 from "./rechnungfreigabe.vue?vue&type=style&index=0&id=35a7a4c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7a4c0",
  null
  
)

export default component.exports